interface CurrencySymbolsTypes {
  [index: string]:
    | {
        [index: string]: string[] | null;
      }
    | string[];
}

const currencySymbols: CurrencySymbolsTypes = {
  AED: ['', 'د.إ'],
  AUD: ['A$'],
  BHD: ['', '.د.ب'],
  CAD: ['C$'],
  DKK: { DK: ['', '\x0akr'], '': null },
  EUR: { IE: ['€'], '': ['', '\x0a€'] },
  GBP: ['£'],
  HKD: ['HK$'],
  ILS: ['₪'],
  JPY: ['', '円'],
  KWD: ['', 'د.ك'],
  NOK: { NO: ['', '\x0akr'], '': null },
  KRW: ['₩'],
  NZD: ['NZ$'],
  OMR: ['', 'ر.ع.'],
  SAR: ['', 'ر.س'],
  SEK: { SE: ['', '\x0akr'], '': null },
  SGD: ['S$'],
  USD: { US: ['$'], '': ['US$'] },
};

const getCurrencySymbols = (currency: string, country: string) => {
  if (!currency) {
    return [];
  }

  let symbols = null;
  if (currencySymbols[currency]) {
    const thisCurrencySymbols = currencySymbols[currency];
    if (Array.isArray(thisCurrencySymbols)) {
      symbols = thisCurrencySymbols;
    } else {
      if (thisCurrencySymbols[country]) {
        symbols = thisCurrencySymbols[country];
      } else {
        symbols = thisCurrencySymbols[''];
      }
    }
  }

  if (!symbols) {
    symbols = ['', `\x0a${currency}`];
  }

  return symbols;
};

export default getCurrencySymbols;
